const ACTIVITY_INDEX_REQUESTS = 0;
const ACTIVITY_INDEX_READS = 1;
/** Unix seconds — fits Int32 until ~2038; sufficient for browse cooldown checks. */
const ACTIVITY_INDEX_LAST_ACTIVITY_SEC = 2;

const activitySharedBuffer = new SharedArrayBuffer(3 * Int32Array.BYTES_PER_ELEMENT);
const mainActivityView = new Int32Array(activitySharedBuffer);

let workerActivityView: Int32Array | null = null;

export function getFileBrowserActivitySharedBuffer(): SharedArrayBuffer {
  return activitySharedBuffer;
}

export function bindFileBrowserActivitySharedBuffer(buffer: SharedArrayBuffer): void {
  workerActivityView = new Int32Array(buffer);
}

export function syncFileBrowserActivityToShared(params: {
  inFlightRequests: number;
  inFlightReads: number;
  lastActivityAt: number;
}): void {
  Atomics.store(mainActivityView, ACTIVITY_INDEX_REQUESTS, params.inFlightRequests);
  Atomics.store(mainActivityView, ACTIVITY_INDEX_READS, params.inFlightReads);
  Atomics.store(
    mainActivityView,
    ACTIVITY_INDEX_LAST_ACTIVITY_SEC,
    Math.floor(params.lastActivityAt / 1000),
  );
}

export function readFileBrowserActivityFromShared(): {
  inFlightRequests: number;
  inFlightReads: number;
  lastActivityAt: number;
} {
  const view = workerActivityView ?? mainActivityView;
  return {
    inFlightRequests: Atomics.load(view, ACTIVITY_INDEX_REQUESTS),
    inFlightReads: Atomics.load(view, ACTIVITY_INDEX_READS),
    lastActivityAt: Atomics.load(view, ACTIVITY_INDEX_LAST_ACTIVITY_SEC) * 1000,
  };
}
